
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../../shared/hooks/useReduxHooks";
import { matrixSlice } from "../../model/matrix-task.slice";
import { submenuSlice } from "../../../../shared/layouts/submenu/model/submenu-model.slice";

export function useMatrixData() {
    const location = useLocation();        
    const dispatch = useAppDispatch();
    function getCountTask() {
        if (location && location.pathname !== '/' && !location.pathname.startsWith('/task/')) {
            dispatch(matrixSlice.actions.setMatrix({isActive: false}))
            dispatch(submenuSlice.actions.setSubmenuCollapse({isCollapsed: false}))
            return {
                isDisabled: true,
                description: 'Режим Матрицы доступен только на \n странице Мой день',
                subDescription: null
            }
        }

        return {
            isDisabled: false,
            description: null,
            subDescription: null
        }
    }

    let getTooltipData = getCountTask();

    return { getTooltipData }
}
